import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchNDATemplate, fetchOrgInfoById } from '../../store/investor/investorApiHelper';
import { closeNDA, setNDAData } from '../../store/investor/action';
import { TEXT_EDITOR_TYPES } from '../../store/investor/constants';
import { AICA_NDA_PREVIEW, AICA_NDA_SAVE } from '../../utils/constants/mixpanelEvents/investorEvents';
import DocumentContainer from '../DocumentEditor/DocumentContainer';

function NDA() {
    const dispatch = useAppDispatch();
    const ndaData = useAppSelector((state) => state.investor.nda);

    return (
        <DocumentContainer
            orgId={ndaData.orgId ?? ''}
            source={ndaData.source ?? ''}
            loading={!!ndaData.loading}
            companyName={ndaData.companyName ?? ''}
            onUnmount={() => dispatch(closeNDA())}
            setLoading={(loading) => dispatch(setNDAData({ loading }))}
            onSaveComplete={() => dispatch(closeNDA())}
            fetchTemplate={fetchNDATemplate}
            docType="NDA"
            fetchExtraMetadata={async (orgId) => {
                const orgInfo = await fetchOrgInfoById({ orgId });
                return { entityType: orgInfo?.constitutionType ?? '' };
            }}
            regenTitle="NDA"
            editorType={TEXT_EDITOR_TYPES.NDA}
            documentType="nda"
            fileNamePrefix="NDA"
            commentContainerId="nda-comment-container"
            mixpanelPreviewEvent={AICA_NDA_PREVIEW}
            mixpanelSaveEvent={AICA_NDA_SAVE}
        />
    );
}

export default NDA;
